import AfterLoginRouteBuilder from '@/middlewares/afterLoginRouteBuilder'
import AuthAPI from '@/api/auth'
import router from '@/router'

const actions = {
  /** ログイン時に呼び出されるアクション */
  async LOGIN({ state, dispatch }, { email, password, cb }) {
    try {
      const response = await AuthAPI.login({ email, password })
      const account = response.item
      await cb()

      // ログイン後に遷移するroutingPathを切り替え
      const { redirectPath } = state
      const routerPath = await AfterLoginRouteBuilder(account)
      router
        .push(redirectPath == null ? routerPath : redirectPath)
        .catch(() => {})
      dispatch('CLEAR_REDIRECT_PATH')
    } catch (e) {
      throw e
    }
  },
  /** ログアウト時に呼び出されるアクション */
  async LOGOUT() {
    try {
      await AuthAPI.logout()
      router.push('/').catch(() => {})
    } catch (e) {
      router.push('/').catch(() => {})
      throw e
    }
  },
  /** ログイン後にリダイレクトするパスをセットする */
  STORE_REDIRECT_PATH({ commit }, path) {
    commit('SET_REDIRECT_PATH', path)
  },
  CLEAR_REDIRECT_PATH({ commit }) {
    commit('SET_REDIRECT_PATH', null)
  },
}

export default actions
